import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { FvcAnalysisSetListScreen } from "./AnalysisSetsList/FvcAnalysisSetList";
import { SpirometryAnalysisScreen } from "./SpirometryAnalysisScreen";
import SpirometrySessionListScreen from "./SessionList/SpirometrySessionListScreen";
import { ActiveSpirometrySessionView } from "./Testing/ActiveSpirometrySessionView";
import { ChallengeOverreaderDecisionPanel } from "../Shared/ChallengeOverreaderDecisionPanel";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { ODataParams, SearchParams } from "../../Components/Query";

export const SpirometryRoot = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <Switch>
            <PrivateRoute path="/Spirometry" exact permissions={[PermissionEnum.AccessSingleFvcSession, PermissionEnum.AccessAllFvcSessions, PermissionEnum.OverreadFvcSession]}>
                <SpirometrySessionListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Spirometry/Analysis" exact permissions={[PermissionEnum.OverreadFvcSession]}>
                <FvcAnalysisSetListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
            </PrivateRoute>
            <PrivateRoute path="/Spirometry/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.AccessSingleFvcSession, PermissionEnum.OverreadFvcSession]}>
                <SpirometryAnalysisScreen />
            </PrivateRoute>
            <PrivateRoute path="/Spirometry/SiteAnalysis/:analysisSetId/:viewState" permissions={PermissionEnum.SiteReviewFvcSession}>
                <ActiveSpirometrySessionView />
            </PrivateRoute>
            <Route path="/Spirometry/:analysisSetId/ChallengeDecision">
                <SpirometrySessionListScreen />
                <ChallengeOverreaderDecisionPanel />
            </Route>
        </Switch>
    );
}
